export class CaseInsensitiveSet {
  private items = new Map<string, string>();

  public add = (value: string): boolean => {
    if (value) {
      const key = value.toLowerCase();
      if (!this.items.has(key)) {
        this.items.set(key, value);
        return true;
      }
    }
    return false;
  };

  public values = (): string[] => Array.from(this.items.values());
}
